import { getStore } from '../store/store';
import type TimeSuggestionsViewState from '../store/schema/TimeSuggestionsViewState';

export function getTimeSuggestionsStore(
    viewStateId: string | null
): TimeSuggestionsViewState | null {
    const timeSuggestionsStore = getStore().viewStates.get(viewStateId);
    if (timeSuggestionsStore) {
        return timeSuggestionsStore;
    } else {
        return null;
    }
}
